import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';
var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#A9B1B9",
  strokeLinecap: "round",
  strokeWidth: "1.5",
  d: "M12 6.95a5.05 5.05 0 1 1-5.024 5.565"
});
function RadialBarChart(_ref) {
  let {
    color = colors.actionMinor[500],
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M12 2.75a9.25 9.25 0 1 1-7.208 3.452"
  }), _ref2);
}
export default RadialBarChart;